var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphoneCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 854",
    style: {
      enableBackground: "new 0 0 432 854"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#00E4B7;}\n\t.st2{fill:#9B59B6;}\n\t.st3{fill:#3498DB;}\n\t.st4{fill:#FF488A;}\n\t.st5{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#34495E;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#8D8D8E;}\n\t.st9{fill:#34495E;}\n\t.st10{fill:#6F00A3;}\n\t.st11{fill:#16C4A3;}\n\t.st12{fill:none;stroke:#D6D6D6;stroke-width:2;stroke-miterlimit:10;}\n\t.st13{fill:#D6D6D6;}\n\t.st14{fill:none;stroke:#AFAFAF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,852C27.1,852,2,826.9,2,796.1V57.9C2,27.1,27.1,2,57.9,2h316.3C404.9,2,430,27.1,430,57.9v738.3 c0,30.8-25.1,55.9-55.9,55.9H57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,4C403.8,4,428,28.2,428,57.9v738.3c0,29.7-24.2,53.9-53.9,53.9H57.9C28.2,850,4,825.8,4,796.1V57.9 C4,28.2,28.2,4,57.9,4H374.1 M374.1,0H57.9C25.9,0,0,25.9,0,57.9v738.3c0,32,25.9,57.9,57.9,57.9h316.3c32,0,57.9-25.9,57.9-57.9 V57.9C432,25.9,406.1,0,374.1,0L374.1,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "notch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M284.6,27H147.4c-5.7,0-10.4-4.6-10.4-10.4V0h158v16.6C295,22.4,290.4,27,284.6,27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.7,17.5c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h44.6c1.8,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2H193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,11.6c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7h-44.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7H238.3 M238.3,10.6 h-44.6c-2.1,0-3.7,1.7-3.7,3.7v0c0,2.1,1.7,3.7,3.7,3.7h44.6c2.1,0,3.7-1.7,3.7-3.7v0C242,12.2,240.3,10.6,238.3,10.6L238.3,10.6z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 248,
    cy: 14.3,
    r: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,836.4c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h83c1.8,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2H174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,830.4c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7h-83c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7H257.5  M257.5,829.4h-83c-2.1,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7h83c2.1,0,3.7-1.7,3.7-3.7C261.2,831.1,259.5,829.4,257.5,829.4 L257.5,829.4z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211,147H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2C219,143.4,215.4,147,211,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M384,173H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h347c4.4,0,8,3.6,8,8v2C392,169.4,388.4,173,384,173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222,199H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h185c4.4,0,8,3.6,8,8v2C230,195.4,226.4,199,222,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74,225H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h37c4.4,0,8,3.6,8,8v2C82,221.4,78.4,225,74,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291,147.5h-40.7c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8H291c4.4,0,8,3.6,8,8v2C299,143.9,295.4,147.5,291,147.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158,274H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h121c4.4,0,8,3.6,8,8v2C166,270.4,162.4,274,158,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358,274H184c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2C366,270.4,362.4,274,358,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358,301H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h321c4.4,0,8,3.6,8,8v2C366,297.4,362.4,301,358,301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273,225H99c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2C281,221.4,277.4,225,273,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296,328H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h259c4.4,0,8,3.6,8,8v2C304,324.4,300.4,328,296,328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,353H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h101c4.4,0,8,3.6,8,8v2C146,349.4,142.4,353,138,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233,353h-71c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h71c4.4,0,8,3.6,8,8v2C241,349.4,237.4,353,233,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M331,353h-72c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v2C339,349.4,335.4,353,331,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319,199h-75c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h75c4.4,0,8,3.6,8,8v2C327,195.4,323.4,199,319,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296,378H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h259c4.4,0,8,3.6,8,8v2C304,374.4,300.4,378,296,378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361,403H151c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h210c4.4,0,8,3.6,8,8v2C369,399.4,365.4,403,361,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114,403H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h77c4.4,0,8,3.6,8,8v2C122,399.4,118.4,403,114,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73,428H36c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h37c4.4,0,8,3.6,8,8v2C81,424.4,77.4,428,73,428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272,428H98c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2C280,424.4,276.4,428,272,428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361,428h-66c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h66c4.4,0,8,3.6,8,8v2C369,424.4,365.4,428,361,428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239,453H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h202c4.4,0,8,3.6,8,8v2C247,449.4,243.4,453,239,453z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M222,495H37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h185c4.4,0,8,3.6,8,8v2C230,491.4,226.4,495,222,495z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319,495h-75c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h75c4.4,0,8,3.6,8,8v2C327,491.4,323.4,495,319,495z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73,521H36c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h37c4.4,0,8,3.6,8,8v2C81,517.4,77.4,521,73,521z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272,521H98c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2C280,517.4,276.4,521,272,521z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295,547H36c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h259c4.4,0,8,3.6,8,8v2C303,543.4,299.4,547,295,547z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136,573H35c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h101c4.4,0,8,3.6,8,8v2C144,569.4,140.4,573,136,573z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231,573h-71c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h71c4.4,0,8,3.6,8,8v2C239,569.4,235.4,573,231,573z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329,573h-72c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h72c4.4,0,8,3.6,8,8v2C337,569.4,333.4,573,329,573z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357,599H35c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h322c4.4,0,8,3.6,8,8v2C365,595.4,361.4,599,357,599z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184,625H35c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h149c4.4,0,8,3.6,8,8v2C192,621.4,188.4,625,184,625z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317,625H209c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h108c4.4,0,8,3.6,8,8v2C325,621.4,321.4,625,317,625z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.6,665.1h-174c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2 C213.6,661.5,210,665.1,205.6,665.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.6,691.1h-347c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h347c4.4,0,8,3.6,8,8v2 C386.6,687.5,383,691.1,378.6,691.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.6,717.1h-185c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h185c4.4,0,8,3.6,8,8v2 C224.6,713.5,221,717.1,216.6,717.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.6,743.1h-37c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h37c4.4,0,8,3.6,8,8v2C76.6,739.5,73,743.1,68.6,743.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M285.6,665.6h-40.7c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h40.7c4.4,0,8,3.6,8,8v2 C293.6,662,290,665.6,285.6,665.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.6,743.1h-174c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h174c4.4,0,8,3.6,8,8v2 C275.6,739.5,272,743.1,267.6,743.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M313.6,717.1h-75c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h75c4.4,0,8,3.6,8,8v2 C321.6,713.5,318,717.1,313.6,717.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "presenting"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 25.5,
    y1: 41.5,
    x2: 60,
    y2: 41.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 25.5,
    y1: 52.2,
    x2: 60,
    y2: 52.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 25.5,
    y1: 63,
    x2: 60,
    y2: 63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "404,58.1 404,64.1 398,64.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "386,64.1 380,64.1 380,58.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "380,46.6 380,40.6 386,40.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "398,40.6 404,40.6 404,46.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 320.3,
    className: "st7",
    width: 95.7,
    height: 95.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.2,
    y: 319.5,
    className: "st7",
    width: 95.7,
    height: 95.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.9,
    y: 319.5,
    className: "st7",
    width: 95.7,
    height: 95.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M102.1,337.4H59.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C103.9,336.6,103.1,337.4,102.1,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.5,361.4H41c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C85.3,360.6,84.5,361.4,83.5,361.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.5,370.4H41c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C85.3,369.6,84.5,370.4,83.5,370.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.5,379.4H41c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C85.3,378.6,84.5,379.4,83.5,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M102.3,405.9H59.8c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C104.1,405.1,103.3,405.9,102.3,405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.1,361.9h-21.3c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C125.9,361.1,125.1,361.9,124.1,361.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.1,370.5h-21.3c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C125.9,369.7,125.1,370.5,124.1,370.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.1,379.5h-21.3c-1,0-1.8-0.8-1.8-1.8v-2c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2 C125.9,378.7,125.1,379.5,124.1,379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.7,336.8h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C237.5,336,236.7,336.8,235.7,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217,360.8h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8H217c1,0,1.8,0.8,1.8,1.8v2.3 C218.8,360,218,360.8,217,360.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217,369.8h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8H217c1,0,1.8,0.8,1.8,1.8v2.3 C218.8,369,218,369.8,217,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217,378.8h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8H217c1,0,1.8,0.8,1.8,1.8v2.3 C218.8,378,218,378.8,217,378.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.9,405.3h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C237.7,404.5,236.9,405.3,235.9,405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M257.7,361.3h-21.3c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C259.4,360.5,258.7,361.3,257.7,361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M257.7,369.9h-21.3c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C259.5,369.1,258.7,369.9,257.7,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M257.7,378.9h-21.3c-1,0-1.8-0.8-1.8-1.8v-2c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2 C259.5,378.1,258.7,378.9,257.7,378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M369.3,336.2h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C371.1,335.4,370.3,336.2,369.3,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M350.6,360.2h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C352.4,359.4,351.6,360.2,350.6,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M350.6,369.2h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C352.4,368.4,351.6,369.2,350.6,369.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M350.6,378.2h-42.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C352.4,377.4,351.6,378.2,350.6,378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M369.5,404.7H327c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h42.5c1,0,1.8,0.8,1.8,1.8v2.3 C371.3,403.9,370.5,404.7,369.5,404.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M391.3,360.7H370c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C393,359.9,392.3,360.7,391.3,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M391.3,369.4H370c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2.3 C393.1,368.6,392.3,369.4,391.3,369.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M391.3,378.4H370c-1,0-1.8-0.8-1.8-1.8v-2c0-1,0.8-1.8,1.8-1.8h21.3c1,0,1.8,0.8,1.8,1.8v2 C393.1,377.6,392.3,378.4,391.3,378.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M369.3,288.5H62.7c-18,0-32.7-14.6-32.7-32.7V143.2c0-18,14.6-32.7,32.7-32.7h306.7c18,0,32.7,14.6,32.7,32.7 v112.7C402,273.9,387.4,288.5,369.3,288.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 182.6,
    className: "st1",
    width: 26.9,
    height: 88.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.4,
    y: 224.7,
    className: "st11",
    width: 26.9,
    height: 46.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 151.7,
    className: "st1",
    width: 26.9,
    height: 119.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.2,
    y: 201.9,
    className: "st11",
    width: 26.9,
    height: 69.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.7,
    y: 211.9,
    className: "st1",
    width: 26.9,
    height: 59.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 224.7,
    className: "st11",
    width: 26.9,
    height: 46.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.2,
    y: 151.7,
    className: "st1",
    width: 26.9,
    height: 119.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.6,
    y: 201.9,
    className: "st11",
    width: 26.9,
    height: 69.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.2,
    y: 211.9,
    className: "st1",
    width: 26.9,
    height: 59.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 212,
    className: "st1",
    width: 26.9,
    height: 59.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 224.9,
    className: "st11",
    width: 26.9,
    height: 46.8
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "48.9,179.5 40,188.5 48.3,196.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st12",
    points: "383.7,196.8 392.6,187.7 384.3,179.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,522.5c-6.4,0-11.6-5.2-11.6-11.6v-56.8c0-6.4,5.2-11.6,11.6-11.6h347.8c6.4,0,11.6,5.2,11.6,11.6v56.8 c0,6.4-5.2,11.6-11.6,11.6H40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,443c6.1,0,11.1,5,11.1,11.1v56.8c0,6.1-5,11.1-11.1,11.1H40.1c-6.1,0-11.1-5-11.1-11.1v-56.8 c0-6.1,5-11.1,11.1-11.1H387.9 M387.9,442H40.1c-6.7,0-12.1,5.4-12.1,12.1v56.8c0,6.7,5.4,12.1,12.1,12.1h347.8 c6.7,0,12.1-5.4,12.1-12.1v-56.8C400,447.4,394.6,442,387.9,442L387.9,442z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.7,457.8h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C385.7,456.5,384.4,457.8,382.7,457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.4,458.1h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C370.3,456.7,369,458.1,367.4,458.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.8,458.2h-159c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h159c1,0,1.8,0.8,1.8,1.8v2.3 C334.6,457.4,333.8,458.2,332.8,458.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217,471.7h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8H217c1,0,1.8,0.8,1.8,1.8v2.3 C218.8,470.9,218,471.7,217,471.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.2,471.7h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C271.9,470.9,271.1,471.7,270.2,471.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.5,482.5h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.2,481.7,271.4,482.5,270.5,482.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.3,493.3h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.1,492.5,271.3,493.3,270.3,493.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 452.5,
    className: "st0",
    width: 95.1,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.3,453v58H40.2v-58H134.3 M135.3,452H39.2v60h96.1V452L135.3,452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 52.5,
    cy: 463,
    rx: 5.1,
    ry: 5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "47.4,507 57.5,500.4 66.9,488.5 79,489.3 103,461.4 131.9,507  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 3.5,
    y1: 82.5,
    x2: 429.5,
    y2: 82.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,609.7c-6.4,0-11.6-5.2-11.6-11.6v-56.8c0-6.4,5.2-11.6,11.6-11.6h347.8c6.4,0,11.6,5.2,11.6,11.6v56.8 c0,6.4-5.2,11.6-11.6,11.6H40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1,530.2c6.1,0,11.1,5,11.1,11.1v56.8c0,6.1-5,11.1-11.1,11.1H40.3c-6.1,0-11.1-5-11.1-11.1v-56.8 c0-6.1,5-11.1,11.1-11.1H388.1 M388.1,529.2H40.3c-6.7,0-12.1,5.4-12.1,12.1v56.8c0,6.7,5.4,12.1,12.1,12.1h347.8 c6.7,0,12.1-5.4,12.1-12.1v-56.8C400.2,534.6,394.8,529.2,388.1,529.2L388.1,529.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383,545h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C385.9,543.7,384.6,545,383,545z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.6,545.3h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C370.5,543.9,369.2,545.3,367.6,545.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M333,545.4H174c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h159c1,0,1.8,0.8,1.8,1.8v2.3 C334.8,544.6,334,545.4,333,545.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217.2,558.9h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C219,558.1,218.2,558.9,217.2,558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.4,558.9h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C272.2,558.1,271.4,558.9,270.4,558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.7,569.7h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.5,568.9,271.7,569.7,270.7,569.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.5,580.5H174c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.3,579.7,271.5,580.5,270.5,580.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 539.7,
    className: "st0",
    width: 95.1,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.5,540.2v58H40.4v-58H134.5 M135.5,539.2H39.4v60h96.1V539.2L135.5,539.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 52.7,
    cy: 550.2,
    rx: 5.1,
    ry: 5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "47.6,594.2 57.8,587.6 67.1,575.7 79.3,576.5 103.2,548.6 132.2,594.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,696.4c-6.4,0-11.6-5.2-11.6-11.6V628c0-6.4,5.2-11.6,11.6-11.6H388c6.4,0,11.6,5.2,11.6,11.6v56.8 c0,6.4-5.2,11.6-11.6,11.6H40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,616.9c6.1,0,11.1,5,11.1,11.1v56.8c0,6.1-5,11.1-11.1,11.1H40.2c-6.1,0-11.1-5-11.1-11.1V628c0-6.1,5-11.1,11.1-11.1 H388 M388,615.9H40.2c-6.7,0-12.1,5.4-12.1,12.1v56.8c0,6.7,5.4,12.1,12.1,12.1H388c6.7,0,12.1-5.4,12.1-12.1V628 C400.1,621.4,394.7,615.9,388,615.9L388,615.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.9,631.7h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C385.8,630.4,384.5,631.7,382.9,631.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.5,632h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C370.4,630.7,369.1,632,367.5,632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.9,632.1h-159c-1,0-1.8-0.8-1.8-1.8V628c0-1,0.8-1.8,1.8-1.8h159c1,0,1.8,0.8,1.8,1.8v2.3 C334.7,631.3,333.9,632.1,332.9,632.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217.1,645.6h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C218.9,644.8,218.1,645.6,217.1,645.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.3,645.6h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C272,644.8,271.2,645.6,270.3,645.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.6,656.4H174c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.3,655.6,271.6,656.4,270.6,656.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.4,667.2h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.2,666.4,271.4,667.2,270.4,667.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.8,
    y: 626.4,
    className: "st0",
    width: 95.1,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.4,626.9v58H40.3v-58H134.4 M135.4,625.9H39.3v60h96.1V625.9L135.4,625.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 52.6,
    cy: 636.9,
    rx: 5.1,
    ry: 5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "47.5,680.9 57.7,674.3 67,662.5 79.2,663.2 103.1,635.3 132.1,680.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,783.6c-6.4,0-11.6-5.2-11.6-11.6v-56.8c0-6.4,5.2-11.6,11.6-11.6h347.8c6.4,0,11.6,5.2,11.6,11.6V772 c0,6.4-5.2,11.6-11.6,11.6H40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,704.1c6.1,0,11.1,5,11.1,11.1V772c0,6.1-5,11.1-11.1,11.1H40.4c-6.1,0-11.1-5-11.1-11.1v-56.8 c0-6.1,5-11.1,11.1-11.1H388.2 M388.2,703.1H40.4c-6.7,0-12.1,5.4-12.1,12.1V772c0,6.7,5.4,12.1,12.1,12.1h347.8 c6.7,0,12.1-5.4,12.1-12.1v-56.8C400.3,708.6,394.9,703.1,388.2,703.1L388.2,703.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.1,718.9h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C386,717.6,384.7,718.9,383.1,718.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.7,719.2h-7.3c-1.6,0-2.9-1.3-2.9-2.9l0,0c0-1.6,1.3-2.9,2.9-2.9h7.3c1.6,0,2.9,1.3,2.9,2.9l0,0 C370.7,717.9,369.3,719.2,367.7,719.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M333.2,719.3h-159c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h159c1,0,1.8,0.8,1.8,1.8v2.3 C334.9,718.5,334.1,719.3,333.2,719.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M217.3,732.8h-43.5c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C219.1,732,218.3,732.8,217.3,732.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.5,732.8H227c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h43.5c1,0,1.8,0.8,1.8,1.8v2.3 C272.3,732,271.5,732.8,270.5,732.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.8,743.6h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.6,742.8,271.8,743.6,270.8,743.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.7,754.4h-96.6c-1,0-1.8-0.8-1.8-1.8v-2.3c0-1,0.8-1.8,1.8-1.8h96.6c1,0,1.8,0.8,1.8,1.8v2.3 C272.4,753.6,271.6,754.4,270.7,754.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 713.6,
    className: "st0",
    width: 95.1,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.6,714.1v58H40.5v-58H134.6 M135.6,713.1H39.5v60h96.1V713.1L135.6,713.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 52.8,
    cy: 724.1,
    rx: 5.1,
    ry: 5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "47.7,768.1 57.9,761.5 67.2,749.7 79.4,750.4 103.3,722.5 132.3,768.1  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneCode);
export default __webpack_public_path__ + "static/media/iphone_code.f7192d33d817074b1702ea7c1668e776.svg";
export { ForwardRef as ReactComponent };